import { useEffect, useState } from 'react';
import { Alert, Button } from '@mui/material';
import { useTranslation } from 'react-i18next';

export function AppUpdateNotice() {
  const { t } = useTranslation();
  const [waiting, setWaiting] = useState<ServiceWorker | null>(null);
  const [activating, setActivating] = useState(false);
  useEffect(() => {
    if (!('serviceWorker' in navigator)) return;
    const inspect = () => { void navigator.serviceWorker.getRegistration().then(registration => setWaiting(registration?.waiting ?? null)); };
    inspect();
    window.addEventListener('swupdate', inspect);
    return () => window.removeEventListener('swupdate', inspect);
  }, []);
  if (!waiting) return null;
  return <Alert severity="info" sx={{ mb: 2 }} action={<Button disabled={activating} onClick={() => {
    setActivating(true);
    // Reload only after an explicit user choice, preserving unfinished forms/carts.
    navigator.serviceWorker.addEventListener('controllerchange', () => window.location.reload(), { once: true });
    waiting.postMessage({ type: 'SKIP_WAITING' });
  }}>{t('pwa.update', 'تحديث الآن')}</Button>}>{t('pwa.updateAvailable', 'تتوفر نسخة جديدة. احفظ عملك ثم حدّث التطبيق.')}</Alert>;
}
